import React from "react";
import useTableData from "./useTableData";
import ListViewCommon from "./ListViewCommon";
import {datetimeColorGradient} from "../../support/colors";

const headers = [
    {"label": "SNR", 'filter': 'string'},
    {"label": "Typ", "caption": "Typ", 'filter': 'string'},
    {"label": "Nazov", "caption": "Názov", 'filter': 'string'},
    {"label": "Vlastnik", "caption": "Vlastník", 'filter': 'string'},
    {"label": "Zakaznik", "caption": "Zákazník", 'filter': 'string'},
    {"label": "Stav_Zapozicky", "caption": "Stav Zápožičky", 'filter': 'string', 'textStyle': 'bold'},
]

function Instruments(props) {
    const initialFilters = [
        {
            'label': 'SNR',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Nazov',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Typ',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Zakaznik',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Vlastnik',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Stav_Zapozicky',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'ordering',
            'lookup': '',
            'value': 'Meno',
        }
    ]
    const baseUrl = '/instrument/demo_instruments'
    const [data, filters, filterUpdate, links, delete_single] = useTableData(baseUrl, initialFilters, parse_links)

    function parse_links(data) {
        return data.map(entry => ({
            'SNR': `/instruments/instrument/${entry.id}`,
        }))
    }

    function colorize() {
        // #TBD: Change from imperative to declarative
        const rows = document.getElementsByTagName("tr")
        const new_rows = Array.from(rows)
        new_rows.splice(0, 2) // Do not color table header
        new_rows.forEach((row, index) => {
            const colorState = data[index].Stav_Farba
            const stateCell = row.getElementsByTagName("td")[5]
            if (colorState !== null) {
                stateCell.style.backgroundColor = colorState
            } else {
                stateCell.style.backgroundColor = "unset"
            }
        })
    }

    React.useEffect(() => {
        colorize()
    }, [data]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <ListViewCommon baseUrlFrontend={`/instruments/instrument`}
                        noColorRows={true}
                        filters={filters}
                        filterUpdate={filterUpdate}
                        links={links}
                        headers={headers}
                        data={data}
                        delete_single={delete_single}
                        label={"Demo Prístroje"}
        />
    )
}

export default Instruments
